// export const url = "https://sandtrust.techhub.devemmy.tech/api/v1";
export const url = "https://api.sandtrustproperties.com/api/v1";
// export const url = "http://api.sandtrustproperties.com/api/v1"
